{
  "title": "Barkskin",
  "source": "Player's Handbook",
  "levelAndSchool": "2nd-level transmutation",
  "level": 2,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a handful of oak bark)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You touch a willing creature. Until the spell ends, the target’s skin has a rough, bark-like appearance, and the target’s AC can’t be less than 16, regardless of what kind of armor it is wearing."
  ],
  "spellLists": ["druid", "ranger"]
}
